import styled from 'styled-components';

export const MemberRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    margin: 10px 0;
`;

export const MemberRowItem = styled.div`
    width: ${props => (props.width ? props.width : 'auto')};
    display: flex;
    align-items: center;
    justify-content: ${props => (props.justify ? props.justify : 'flex-start')};
    padding: 0 5px;
    // overflow-x: hidden;
    position: relative;
`;

export const MemberRowHeaderItem = styled(MemberRowItem)`
    font-size: 12px;
    opacity: 0.5;
    font-weight: bold;
    color: #fff;
    text-transform: uppercase;
`;

export const CreditInput = styled.input`
    width: 52px;
    height: 30px;
    border-radius: 3px;
    border: none;
    background-color: rgba(239, 240, 242, 0.18);
    text-align: center;
    font-size: 14px;
    color: #909fac;
    outline: none;

    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    &:disabled {
        opacity: 0.5;
    }
`;

export const SelectContainer = styled.div`
    width: 288px;
    background-color: #0e0e0e;
    position: absolute;
    top: 20px;
    left: 0;
    border-radius: 3px;
    border: solid 1px #979797;
    background-color: #000000;
    z-index: 1000;
    max-height: 120px;
    overflow-y: auto;
`;

export const Checked = styled.div`
    width: 10px;
    height: 10px;
    position: absolute;
    top: 10px;
    left: 10px;
    background: linear-gradient(to bottom, #fb711c, #fa2e58);
`;

export const TransparentBackground = styled.div`
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100000;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Rows/MemberRow/style.js